import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type { EnvelopeAccessLinkUrlResponse } from './access-links.types'

const getEnvelopeAccessLinkUrl = async (
  envelopeId: string,
  linkId: string,
): Promise<EnvelopeAccessLinkUrlResponse> => {
  const response = await apiClient.get<EnvelopeAccessLinkUrlResponse>(
    `/v1/ecm/envelopes/${envelopeId}/access-links/${linkId}/url`,
  )
  return response.data
}

export const useGetEnvelopeAccessLinkUrl = (
  envelopeId: string,
  feedback?: MutationFeedback,
) => {
  return useMutation({
    mutationFn: (linkId: string) =>
      getEnvelopeAccessLinkUrl(envelopeId, linkId),
    meta: { ...feedback },
  })
}
